/** What a tap inside a phone result row must leave alone: the row's own controls (P/Member_Hub.html:1014). */
export const ROW_TAP_IGNORE_SELECTOR = 'a, button, input, select, textarea, label';

/**
 * Whether a click on a phone result row is a tap on the row itself — not on one of its links, buttons or fields — and so opens the
 * row's item ("whole row opens its item on phones", P/Member_Hub.html:1011-1019).
 */
export function IsRowTap(event: Event): boolean {
    const target = event.target;
    if (!(target instanceof Element)) return false;
    return target.closest(ROW_TAP_IGNORE_SELECTOR) === null;
}
